package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.Car
import de.oevbs.kunde.kundenportal2.components.detailsGrid
import de.oevbs.kunde.kundenportal2.components.detailsGridEntry
import de.oevbs.kunde.kundenportal2.components.pdfDownloadButton
import de.oevbs.kunde.kundenportal2.components.separator
import de.oevbs.kunde.kundenportal2.services.contract.clausesSection
import de.oevbs.kunde.kundenportal2.services.contract.detailsSection
import de.oevbs.kunde.kundenportal2.services.contract.toJaNein
import de.oevbs.kunde.kundenportal2.services.contract.withLastElementFlag
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails der Sparte KFZ
 *
 * @param car beinhaltet die Sparten spezifischen Informationen
 */
fun RenderContext.contractDetailsCar(car: Car) {
    detailsSection("Daten zu Ihrer Kraftfahrzeugversicherung") {
        detailsGrid {
            detailsGridEntry("Kennzeichen", car.licensePlateNumber)
            detailsGridEntry("Fahrzeugtyp", car.typeText)
            detailsGridEntry("Fahrzeugart", car.riskText)
            detailsGridEntry("Erwerbsdatum", car.dateOfPurchase?.toLocalizedString())
            detailsGridEntry("Hersteller", car.manufacturerText)
            detailsGridEntry("Hubraum", "${car.displacement} ccm")
            detailsGridEntry("Fahrgestellnummer", car.chassisNumber)
            detailsGridEntry("Erstzulassung", car.firstRegistration?.toLocalizedString())
            detailsGridEntry("Stärke", "${car.power} kw")
        }
    }

    detailsSection("Ihr Versicherungsschutz") {
        detailsGrid {
            detailsGridEntry("Produktvariante", car.productVariant)
            detailsGridEntry("Selbstbeteiligung", car.comprehensive.coverageTypeText)
            detailsGridEntry("Kfz-Haftpflicht", car.liability.coverageTypeText)
            detailsGridEntry("Autoschutzbrief", car.liability.isBreakdownInsurance.toJaNein())
            detailsGridEntry("Teilkasko (TK)", car.comprehensive.coverageTypeText.contains("TK").toJaNein())
            detailsGridEntry("Rabattschutz", car.liability.isDiscountProtection.toJaNein())
            detailsGridEntry("Vollkasko (VK)", car.comprehensive.coverageTypeText.contains("VK").toJaNein())
            detailsGridEntry("Werkstatt-Service", car.comprehensive.isGarageService.toJaNein())
        }
    }

    if (car.clauses.isNotEmpty()) {
        detailsSection("Klauseln") {
            clausesSection(car.clauses)
        }
    }

    detailsSection("Merkmale zur Beitragsrechnung") {
        detailsGrid {
            detailsGridEntry("Wohneigentum", car.tariffCriteria.homeOwnership)
            detailsGridEntry("Nächtlicher Abstellplatz", car.tariffCriteria.parkingArea)
            detailsGridEntry("Jährliche Fahrleistung", "${car.tariffCriteria.kmPerYear} km")
            detailsGridEntry("Tachostand", "${car.tariffCriteria.mileage} km")
            detailsGridEntry("Tachostand per", car.tariffCriteria.mileageDate?.toLocalizedString())
            detailsGridEntry("abweichender Halter", car.tariffCriteria.ownerRole)
        }
        contractDetailsCarPremiumTable(car)
    }
}

/**
 * Rendering der Beitragsübersichtstabelle für Kasko und Haftpflicht
 */
private fun RenderContext.contractDetailsCarPremiumTable(car: Car) {
    table("w-full table-auto") {
        thead("border-b border-gray-200") {
            tr("text-left") {
                th("p-2") { +"" }
                th("p-2") { +"Kfz-Haftpflicht" }
                th("p-2") { +"Kfz-Kasko" }
            }
        }
        tbody {
            tr {
                td("p-2") { strong { +"Regionalklasse" } }
                td("p-2") { +car.liability.regionalClass }
                td("p-2") { +car.comprehensive.regionalClass }
            }
            tr {
                td("p-2") { strong { +"Typklasse" } }
                td("p-2") { +car.liability.typeClass.toString() }
                td("p-2") { +car.comprehensive.typeClass.toString() }
            }
            tr {
                td("p-2") { strong { +"Schadenfreiheitsklasse" } }
                td("p-2") { +car.liability.noClaimsClassCurrentYear.toString() }
                td("p-2") { +car.comprehensive.noClaimsClassCurrentYear.toString() }
            }
            tr {
                td("p-2") { strong { +"Schadenfreiheit in Prozent" } }
                td("p-2") { +car.liability.premiumRateCurrentYear.toString() }
                td("p-2") { +car.comprehensive.premiumRateCurrentYear.toString() }
            }
        }
    }
}